import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/manrope';
import './index.css';
import AppRouter from './AppRouter';

// Die Seiten werden beim Build vorgerendert (scripts/postbuild.js). React
// übernimmt beim Laden das vorhandene HTML und rendert es neu.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>
);
